// extracted by mini-css-extract-plugin
module.exports = {"root":"Body_root__jrXlU","top":"Body_top__nKYtS"};